import { render, staticRenderFns } from "./OutpatientReviewASCGrouping.vue?vue&type=template&id=54d2002e&scoped=true&"
import script from "./OutpatientReviewASCGrouping.vue?vue&type=script&lang=js&"
export * from "./OutpatientReviewASCGrouping.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReviewASCGrouping.vue?vue&type=style&index=0&id=54d2002e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d2002e",
  null
  
)

export default component.exports